import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Stack, IconButton, Typography } from "@mui/material";

import CancelRoundedIcon from "@mui/icons-material/CancelRounded";

export default function ShoppingCartHeader({ onCloseClick = () => {} }) {
  const { t } = useTranslation();

  return (
    <Stack
      width="100%"
      padding="16px 24px"
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Typography color="secondary" variant="h5" fontWeight={700}>
        {t("shopping_cart.title")}
      </Typography>
      <IconButton onClick={onCloseClick()} sx={{ marginRight: "-12px" }}>
        <CancelRoundedIcon fontSize="large" color="secondary" />
      </IconButton>
    </Stack>
  );
}
